var map = {
	"./1200px-Telegram_2019_Logo.svg.webp": 100,
	"./airbnbLogo.png": 28,
	"./codeInLogo.webp": 29,
	"./contactMail.webp": 101,
	"./contactMailDark.svg": 102,
	"./developerActivity.svg": 33,
	"./facebookLogo.png": 26,
	"./googleAssistant.svg": 103,
	"./googleAssistantLogo.webp": 30,
	"./harvardLogo.png": 104,
	"./iit-delhi-logo.png": 25,
	"./jsFramework.svg": 105,
	"./manOnTable.svg": 32,
	"./nextuLogo.webp": 106,
	"./programmer.svg": 107,
	"./pwa.webp": 108,
	"./pwaLogo.webp": 109,
	"./quoraLogo.png": 27,
	"./saayaHealthLogo.webp": 110,
	"./skill.svg": 34,
	"./stanfordLogo.png": 111,
	"./talksCardBack.svg": 112,
	"./talksCardBackAlt.svg": 113,
	"./telegram.jpg": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;